export default "__VITE_ASSET__CGYThbJ8__"